/* Filtro por estado del Portfolio: el desplegable fija data-filter en la
   seccion y el CSS oculta los elementos (lista + galeria) que no coinciden. */
(function () {
  function initPortfolio(root) {
    var select = root.querySelector('.portfolio__filter-select');
    if (!select || select.dataset.pfBound) return;
    select.dataset.pfBound = 'true';
    var apply = function () {
      root.setAttribute('data-filter', select.value || 'all');
    };
    select.addEventListener('change', apply);
    apply();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.portfolio').forEach(initPortfolio);
  }

  initAll();
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
